import React from 'react';
import './Pricing.css';

const PricingTable = () => {
  // Main pricing data
  const pricingData = [
    { bedBath: "1/1", size: 1000, standard: 130, deep: 220, move: 250 },
    { bedBath: "2/2", size: 1500, standard: 160, deep: 280, move: 300 },
    { bedBath: "3/2", size: 2000, standard: 200, deep: 330, move: 350 },
    { bedBath: "3/3", size: 2500, standard: 220, deep: 360, move: 380 },
    { bedBath: "4/3", size: 2500, standard: 250, deep: 400, move: 420 },
    { bedBath: "4/4", size: 3000, standard: 280, deep: 450, move: 480 },
  ];

  // Extras data
  const extras = [
    { name: "Oven", price: 40 },
    { name: "Fridge", price: 40 },
    { name: "Blinds", price: 20 },
    { name: "Dishes", price: 25 },
    { name: "Windows", price: 30 },
  ];

  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-content">
        <h2 className="pricing-title">Our Pricing</h2>
        <p className="pricing-subtitle">
          Choose the perfect cleaning option for your home. Transparent and upfront pricing – no surprises!
        </p>

        <div className="table-wrapper">
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Bed / Bath</th>
                <th>Size (sqft)</th>
                <th>Standard Clean</th>
                <th>Deep Clean</th>
                <th>Move In/Out</th>
              </tr>
            </thead>
            <tbody>
              {pricingData.map((row, index) => (
                <tr key={index}>
                  <td>{row.bedBath}</td>
                  <td>{row.size}</td>
                  <td>${row.standard}</td>
                  <td>${row.deep}</td>
                  <td>${row.move}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h3 className="extras-title">Extras</h3>
        <ul className="extras-list">
          {extras.map((extra, index) => (
            <li key={index}>
              {extra.name} – ${extra.price}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default PricingTable;
